import { ref, computed } from 'vue';

const icons = [
  { name: 'home', class: 'uil uil-home', label: 'Home Icon' },
  { name: 'user', class: 'uil uil-user', label: 'User Icon' },
  { name: 'edit', class: 'uil uil-edit', label: 'Edit Icon' },
  { name: 'trash', class: 'uil uil-trash', label: 'Trash Icon' },
  { name: 'search', class: 'uil uil-search', label: 'Search Icon' },
  { name: 'setting', class: 'uil uil-setting', label: 'Settings Icon' },
  { name: 'bell', class: 'uil uil-bell', label: 'Notification Icon' },
  { name: 'envelope', class: 'uil uil-envelope', label: 'Email Icon' },
  { name: 'heart', class: 'uil uil-heart', label: 'Heart Icon' },
  { name: 'star', class: 'uil uil-star', label: 'Star Icon' },
  { name: 'chart', class: 'uil uil-chart', label: 'Chart Icon' },
  { name: 'calendar', class: 'uil uil-calendar-alt', label: 'Calendar Icon' },
  { name: 'dollar', class: 'uil uil-usd-square', label: 'Dollar Icon' },
  { name: 'bitcoin', class: 'uil uil-bitcoin-circle', label: 'Bitcoin Icon' },
  { name: 'hospital', class: 'uil uil-hospital', label: 'Hospital Icon' },
  { name: 'thermometer', class: 'uil uil-thermometer', label: 'Thermometer Icon' },
  { name: 'microscope', class: 'uil uil-microscope', label: 'Microscope Icon' },
  { name: 'estate', class: 'uil uil-estate', label: 'Real Estate Icon' },
  { name: 'bus', class: 'uil uil-bus', label: 'Bus Icon' },
  { name: 'shopping', class: 'uil uil-shopping-bag', label: 'Shopping Icon' },
  { name: 'news', class: 'uil uil-newspaper', label: 'News Icon' },
  { name: 'palette', class: 'uil uil-palette', label: 'Palette Icon' },
  { name: 'trophy', class: 'uil uil-trophy', label: 'Trophy Icon' },
  { name: 'shield', class: 'uil uil-shield-check', label: 'Shield Icon' },
  { name: 'graduation', class: 'uil uil-graduation-cap', label: 'Graduation Icon' },
  { name: 'university', class: 'uil uil-university', label: 'University Icon' },
  { name: 'megaphone', class: 'uil uil-megaphone', label: 'Megaphone Icon' },
  { name: 'robot', class: 'uil uil-robot', label: 'Robot Icon' },
  { name: 'rocket', class: 'uil uil-rocket', label: 'Rocket Icon' },
  { name: 'bolt', class: 'uil uil-bolt-alt', label: 'Lightning Bolt Icon' },
  { name: 'industry', class: 'uil uil-building', label: 'Industry Icon' },
  { name: 'phone', class: 'uil uil-phone', label: 'Phone Icon' },
  { name: 'volume', class: 'uil uil-volume-up', label: 'Volume Icon' },
  { name: 'car', class: 'uil uil-car', label: 'Car Icon' },
  { name: 'database', class: 'uil uil-database', label: 'Database Icon' },
  { name: 'file', class: 'uil uil-file-alt', label: 'File Icon' },
  { name: 'chart', class: 'uil uil-chart-line', label: 'Chart Icon' },
  { name: 'video', class: 'uil uil-video', label: 'Video Icon' },
  { name: 'music', class: 'uil uil-music', label: 'Music Icon' },
  { name: 'image', class: 'uil uil-image', label: 'Image Icon' },
  { name: 'cube', class: 'uil uil-cube', label: 'Cube Icon' },
  { name: 'map', class: 'uil uil-map', label: 'Map Icon' },
  { name: 'graph', class: 'uil uil-graph-bar', label: 'Graph Icon' },
  { name: 'brackets', class: 'uil uil-brackets-curly', label: 'Brackets Icon' },
  { name: 'robot', class: 'uil uil-robot', label: 'Robot Icon' },
  { name: 'volume', class: 'uil uil-volume', label: 'Volume Icon' },
  { name: 'music', class: 'uil uil-music', label: 'Music Icon' },
  { name: 'image-check', class: 'uil uil-image-check', label: 'Image Check Icon' },
  { name: 'bolt', class: 'uil uil-bolt', label: 'Bolt Icon' },
  { name: 'question', class: 'uil uil-question', label: 'Question Icon' },
  { name: 'database-alt', class: 'uil uil-database-alt', label: 'Database Alt Icon' },
  { name: 'bullseye', class: 'uil uil-bullseye', label: 'Bullseye Icon' },
  { name: 'heart', class: 'uil uil-heart', label: 'Heart Icon' },
  { name: 'basketball', class: 'uil uil-basketball', label: 'Basketball Icon' },
  { name: 'award', class: 'uil uil-award', label: 'Award Icon' },
  { name: 'chart-pie', class: 'uil uil-chart-pie', label: 'Chart Pie Icon' },
  { name: 'cloud', class: 'uil uil-cloud', label: 'Cloud Icon' },
  { name: 'code-branch', class: 'uil uil-code-branch', label: 'Code Branch Icon' },
  { name: 'dna', class: 'uil uil-dna', label: 'DNA Icon' },
  { name: 'plane', class: 'uil uil-plane', label: 'Plane Icon' },
  { name: 'traffic-light', class: 'uil uil-traffic-light', label: 'Traffic Light Icon' },
  { name: 'trophy', class: 'uil uil-trophy', label: 'Trophy Icon' },
  { name: 'umbrella', class: 'uil uil-umbrella', label: 'Umbrella Icon' },
  { name: 'briefcase', class: 'uil uil-briefcase', label: 'Management Occupations' },
  { name: 'money-bill', class: 'uil uil-money-bill', label: 'Business and Financial Operations' },
  { name: 'calculator', class: 'uil uil-calculator', label: 'Computer and Mathematical Occupations' },
  { name: 'ruler', class: 'uil uil-ruler', label: 'Architecture and Engineering' },
  { name: 'flask', class: 'uil uil-flask', label: 'Life, Physical, and Social Science' },
  { name: 'users-alt', class: 'uil uil-users-alt', label: 'Community and Social Service' },
  { name: 'balance-scale', class: 'uil uil-balance-scale', label: 'Legal Occupations' },
  { name: 'book-open', class: 'uil uil-book-open', label: 'Educational Instruction and Library' },
  { name: 'palette', class: 'uil uil-palette', label: 'Arts, Design, Entertainment, Sports, Media' },
  { name: 'stethoscope', class: 'uil uil-stethoscope', label: 'Healthcare Practitioners and Technical' },
  { name: 'band-aid', class: 'uil uil-band-aid', label: 'Healthcare Support' },
  { name: 'shield', class: 'uil uil-shield', label: 'Protective Service' },
  { name: 'utensils', class: 'uil uil-utensils', label: 'Food Preparation and Serving' },
  { name: 'building', class: 'uil uil-building', label: 'Building and Grounds Maintenance' },
  { name: 'smile', class: 'uil uil-smile', label: 'Personal Care and Service' },
  { name: 'shopping-cart', class: 'uil uil-shopping-cart', label: 'Sales and Related Occupations' },
  { name: 'clipboard-notes', class: 'uil uil-clipboard-notes', label: 'Office and Administrative Support' },
  { name: 'flower', class: 'uil uil-flower', label: 'Farming, Fishing, and Forestry' },
  { name: 'hard-hat', class: 'uil uil-hard-hat', label: 'Construction and Extraction' },
  { name: 'wrench', class: 'uil uil-wrench', label: 'Installation, Maintenance, and Repair' },
  { name: 'cog', class: 'uil uil-cog', label: 'Production Occupations' },
  { name: 'truck', class: 'uil uil-truck', label: 'Transportation and Material Moving' },
  { name: 'crosshair', class: 'uil uil-crosshair', label: 'Military Specific Occupations' },
  { name: 'brain', class: 'uil uil-brain', label: 'Brain Icon' },
  { name: 'exclamation-triangle', class: 'uil uil-exclamation-triangle', label: 'Caution Icon' },
  { name: 'globe', class: 'uil uil-globe', label: 'Globe Icon' },
  { name: 'wifi', class: 'uil uil-wifi', label: 'WiFi Icon' },
  { name: 'code', class: 'uil uil-code', label: 'Code Icon' },
  { name: 'cpu', class: 'uil uil-processor', label: 'Processor Icon' },
  { name: 'server', class: 'uil uil-server', label: 'Server Icon' },
  { name: 'camera', class: 'uil uil-camera', label: 'Camera Icon' },
  { name: 'lock', class: 'uil uil-lock', label: 'Lock Icon' },
  { name: 'key', class: 'uil uil-key-skeleton', label: 'Key Icon' },
  { name: 'user-check', class: 'uil uil-user-check', label: 'User Check Icon' },
  { name: 'user-plus', class: 'uil uil-user-plus', label: 'User Plus Icon' },
  { name: 'id-card', class: 'uil uil-id-card', label: 'ID Card Icon' },
  { name: 'tag', class: 'uil uil-tag', label: 'Tag Icon' },
  { name: 'bookmark', class: 'uil uil-bookmark', label: 'Bookmark Icon' },
  { name: 'flag', class: 'uil uil-flag', label: 'Flag Icon' },
  { name: 'gift', class: 'uil uil-gift', label: 'Gift Icon' },
  { name: 'fire', class: 'uil uil-fire', label: 'Fire Icon' },
  { name: 'water-drop', class: 'uil uil-water-drop', label: 'Water Drop Icon' },
  { name: 'sun', class: 'uil uil-sun', label: 'Sun Icon' },
  { name: 'moon', class: 'uil uil-moon', label: 'Moon Icon' },
  { name: 'check-circle', class: 'uil uil-check-circle', label: 'Check Circle Icon' },
  { name: 'times-circle', class: 'uil uil-times-circle', label: 'Times Circle Icon' },
  { name: 'plus-circle', class: 'uil uil-plus-circle', label: 'Plus Circle Icon' },
  { name: 'minus-circle', class: 'uil uil-minus-circle', label: 'Minus Circle Icon' },
  { name: 'info-circle', class: 'uil uil-info-circle', label: 'Info Circle Icon' },
  { name: 'exclamation-circle', class: 'uil uil-exclamation-circle', label: 'Alert Circle Icon' },
  { name: 'map-marker', class: 'uil uil-map-marker', label: 'Map Marker Icon' },
  { name: 'compass', class: 'uil uil-compass', label: 'Compass Icon' },
  { name: 'folder', class: 'uil uil-folder', label: 'Folder Icon' },
  { name: 'folder-open', class: 'uil uil-folder-open', label: 'Folder Open Icon' },
  { name: 'folder-plus', class: 'uil uil-folder-plus', label: 'Folder Plus Icon' },
  { name: 'file-plus', class: 'uil uil-file-plus', label: 'File Plus Icon' },
  { name: 'upload', class: 'uil uil-upload', label: 'Upload Icon' },
  { name: 'download', class: 'uil uil-download', label: 'Download Icon' },
  { name: 'share', class: 'uil uil-share', label: 'Share Icon' },
  { name: 'link', class: 'uil uil-link', label: 'Link Icon' },
  { name: 'paperclip', class: 'uil uil-paperclip', label: 'Paperclip Icon' },
  { name: 'clipboard', class: 'uil uil-clipboard', label: 'Clipboard Icon' },
  { name: 'list', class: 'uil uil-list-ul', label: 'List Icon' },
  { name: 'list-ordered', class: 'uil uil-list-ol', label: 'Ordered List Icon' },
  { name: 'bars', class: 'uil uil-bars', label: 'Menu Bars Icon' },
  { name: 'sliders', class: 'uil uil-sliders-v-alt', label: 'Sliders Icon' },
  { name: 'filter', class: 'uil uil-filter', label: 'Filter Icon' },
  { name: 'sort', class: 'uil uil-sort', label: 'Sort Icon' },
  { name: 'sync', class: 'uil uil-sync', label: 'Sync Icon' },
  { name: 'refresh', class: 'uil uil-refresh', label: 'Refresh Icon' },
  { name: 'history', class: 'uil uil-history', label: 'History Icon' },
  { name: 'clock', class: 'uil uil-clock', label: 'Clock Icon' },
  { name: 'stopwatch', class: 'uil uil-stopwatch', label: 'Stopwatch Icon' },
];

export function useIconSelect() {
  const searchQuery = ref('');

  const filteredIcons = computed(() => {
    if (!searchQuery.value) return icons;
    const query = searchQuery.value.toLowerCase();
    return icons.filter(icon => 
      icon.label.toLowerCase().includes(query) || 
      icon.name.toLowerCase().includes(query)
    );
  });

  const getIconByName = (name) => {
    return icons.find(icon => icon.name === name);
  };

  const getAllIcons = () => icons;

  return {
    icons,
    searchQuery,
    filteredIcons,
    getIconByName,
    getAllIcons
  };
}